/* eslint-disable @typescript-eslint/no-explicit-any */
import { AbstractControl, FormGroup } from '@angular/forms';

export function getFormControl(
  controlName: string,
  form: FormGroup,
): AbstractControl<any, any> {
  return form.controls[controlName];
}

export function setFormErrors(controlName: string, form: FormGroup): boolean {
  const control = form.get(controlName);
  if (!control) return false;

  const isTouchedOrDirty =
    control.touched || control.dirty || !control.pristine;
  if (!isTouchedOrDirty) return false;

  return (
    control.hasError('email') ||
    control.hasError('required') ||
    control.hasError('min') ||
    control.hasError('max') ||
    control.hasError('passwordMismatch') ||
    control.hasError('outOfRange')
  );
}

export function getControlErrorDetail(
  controlName: string,
  form: FormGroup,
): string | undefined {
  const control: any = form.get(controlName);
  if (control) {
    if (control?.hasError('required')) {
      return 'Campo obligatorio';
    }
    if (control?.hasError('email')) {
      return 'No es un correo electrónico válido';
    }
    if (control?.hasError('passwordMismatch')) {
      return 'Las contraseñas no coinciden';
    }
    if (control?.hasError('outOfRange')) {
      return 'La fecha seleccionada está fuera del rango permitido';
    }
  }
  return undefined;
}

export function setNumericStringToInteger(
  valueToParse: string | number,
): number {
  return parseInt(valueToParse + '', 10);
}
